<template>
  <div class="shrink-0 px-6 flex flex-row gap-2">
    <div class="w-2/3">
      <BaseSearchInput v-model="terms" />
    </div>
    <div class="w-1/3">
      <slot name="top-left-cta" />
    </div>
  </div>
  <div class="flex-1 flex flex-col min-h-0 overflow-y-auto">
    <div class="flex flex-col gap-2 px-6 pb-4">
      <h4 class="font-bold">{{ $t('global.already_chosen') }}</h4>
      <div class="flex flex-col gap-4 -mx-4 px-4">
        <template v-for="user in selectedUsers" :key="user.id">
          <slot name="selected-user-panel" :user="user">
            <div class="flex flex-row items-center gap-4" data-avatar-shape="square">
              <UserAvatar
                :user-id="user.id"
                size="large"
                hide-status
                flat
              />
              <div class="flex-1 flex flex-col">
                <h3 class="font-bold text-base leading-tight">
                  {{ user.full_name }}
                </h3>
              </div>
              <div class="shrink-0"></div>
            </div>
          </slot>
        </template>
      </div>
    </div>
    <div class="flex flex-col gap-2 bg-gray-100 border-t px-6 pt-2">
      <h4 class="font-bold">{{ $t('global.not_yet_chosen') }}</h4>
      <div class="flex flex-1 min-h-0 flex-col gap-4 px-4 -mx-4">
        <template v-for="user in selectableUser" :key="user.id">
          <slot name="selectable-user-panel" :user="user">
            <div class="flex flex-row items-center gap-4" data-avatar-shape="square">
              <UserAvatar
                :user-id="user.id"
                size="large"
                hide-status
                flat
              />
              <div class="flex-1 flex flex-col">
                <h3 class="font-bold text-base leading-tight">
                  {{ user.full_name }}
                </h3>
              </div>
              <div v-if="editionMode" class="shrink-0 flex items-center">
                <BaseButton
                  :title="$t('button.add')"
                  icon="plus"
                  size="extra-small"
                  inverse-icon-order
                  @click="$emit('add-user', user.id)"
                />
              </div>
            </div>
          </slot>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import UserAvatar from '@c/Avatar/UserAvatar.vue'
import BaseSearchInput from '@c/addf-package/components/BaseInput/BaseSearchInput.vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'
import { mapGetters } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default defineComponent({
  name: 'UsersPanel',
  components: { BaseButton, SelectComponent, BaseSearchInput, UserAvatar },
  props: {
    selectedUsers: {
      type: Array,
      required: true
    },
    filter: {
      type: Function,
      required: false,
      default: undefined
    },
    editionMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['add-user'],
  data() {
    return {
      terms: ''
    }
  },
  computed: {
    ...mapGetters({
      users: 'metadata/getUsersMetadata'
    }),
    selectedUserIds() {
      return this.selectedUsers.map((user) => user.id)
    },
    selectableUser() {
      return this.users
        .filter((user) => {
          return !this.selectedUserIds.includes(user.id)
        })
        .filter((user) => {
          return (
            this.terms.length === 0 ||
            this.$h.normalizeSearch(user.full_name).includes(this.$h.normalizeSearch(this.terms))
          )
        })
        .filter((user) => {
          return typeof this.filter !== 'function' || this.filter(user)
        })
    }
  }
})
</script>

<style scoped></style>
